/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import {
  doLog,
  getMMDDYYYY,
  hasValue,
  // LogDebug,
  notNull,
} from "../../../shared/utility";

// import { alpha } from "@material-ui/core/styles";
//import Autocomplete from "@material-ui/lab/Autocomplete";
import classes from "./FormField.css";
import Checkbox from "@material-ui/core/Checkbox";
// import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { DataGrid } from "@mui/x-data-grid";
// import CoreDataGrid from "../CoreDataGrid";
import { DEFAULT_GRID_OPTIONS } from "@material-ui/x-grid";
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
// import { KeyboardDateTimePicker } from "@material-ui/pickers";
import emailMask from "text-mask-addons/dist/emailMask";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MaskedInput from "react-text-mask";
import MenuItem from "@material-ui/core/MenuItem";
import NumberFormat from "react-number-format";
// import ReactAux from "../../../hoc/AuxFolder/reactaux";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
// import Select from "react-select";
// import Select from 'react-dropdown-select';
// import { alpha } from "@material-ui/core/styles";
// import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";

// import Box from "@mui/material/Box";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

const getTextControl_EmailFormat = (props) => {
  const { inputRef, onChange, ...other } = props;

  return <MaskedInput {...other} mask={emailMask} onChange={onChange} />;
};

const getTextControl_DateFormat = (props) => {
  const { inputRef, onChange, ...other } = props;
  // if (doLog()) console.log('getTextControl_DateFormat props:', props);
  return (
    <NumberFormat
      {...other}
      format="##/##/####"
      mask="_"
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

const getTextControl_HeightFormat = (props) => {
  const { inputRef, onChange, ...other } = props;
  const heightMask = [/[1-7]/, "'", /[0-1]/, /[0-9]/, '"'];
  return <MaskedInput {...other} mask={heightMask} onChange={onChange} />;
};

const getTextControl_NumberFormat = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

const getTextControl_NumberFormatMoney = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix={"$"}
      decimalScale={2}
      fixedDecimalScale
    />
  );
};

const getTextControl_PhoneFormat = (props) => {
  const { inputRef, onChange, ...other } = props;
  // if (doLog()) console.log('getTextControl_PhoneFormat props:', props);
  return (
    <NumberFormat
      {...other}
      format="(###) ###-####"
      mask="_"
      getInputRef={inputRef}
      variant="outlined"
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

const getTextControl_SSNFormat = (props) => {
  const { inputRef, onChange, ...other } = props;
  // if (doLog()) console.log('getTextControl_SSNFormat props:', props);
  return (
    <NumberFormat
      {...other}
      format="###-##-####"
      mask="_"
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

const formField = (props) => {
  let fieldElement = null;
  const inputClasses = [classes.InputElement];
  const showLabel = props.showLabel;
  let error = false;
  let validationError = null;
  let rowCount = 1;
  let separateLabelAbove = true;
  let separateLabel = null;
  let fieldLabel = props.label;
  let disabled = props.disabled;

  // const apiRef = useGridApiRef();

  if (doLog())
    console.log("[FormField] field:" + props.fieldName + " props:", props);
  if (props.rows) rowCount = props.rows;

  if (separateLabelAbove && props.inputType !== "checkbox") {
    const separateLabelStr = props.label;
    const requiredStr =
      props.required && hasValue(separateLabelStr) ? " *" : "";
    separateLabel = (
      <p className={classes.SeparateLabel}>
        {separateLabelStr}
        <span className={classes.Required}>{requiredStr}</span>
      </p>
    );

    fieldLabel = null;
  }

  const disableNonEditMode = props.useDisabledForNonEdit;
  // const textVariant = 'filled';
  const textVariant = "outlined";
  const textMargin = "dense";
  // const textMargin = "normal";
  const textNotched = "false";

  // if (doLog()) console.log('[FormField] fieldName:',  props.fieldName);
  // if (doLog()) console.log('[FormField] editMode:',  props.editMode);
  // if (doLog()) console.log('[FormField] invalid:',  props.invalid);
  // if (doLog()) console.log('[FormField] inputType:',  props.inputType);
  // if (doLog()) console.log('[FormField] value:',  props.value);
  // if (doLog()) console.log('[FormField] rows:', props.rows);
  if (!props.skip) {
    if (props.editMode || disableNonEditMode) {
      // if (props.invalid && props.shouldValidate && props.touched) {
      if (props.invalid) {
        inputClasses.push(classes.Invalid);
        // validationError = <p>Please enter a valid value</p>;
        validationError = props.invalidMsg;
        error = true;
      }
      switch (props.inputType) {
        //=======================================================================
        case "checkbox":
          // if (doLog()) console.log('[FormField] checkedValue:',  props.checkedValue);
          fieldElement = (
            <FormControlLabel
              disabled={!props.editMode}
              control={
                <Checkbox
                  checked={props.value === props.checkedValue}
                  onChange={props.onChange}
                  color="default"
                />
              }
              label={fieldLabel}
            />
          );
          break;
        //=======================================================================
        case "email":
          fieldElement = (
            <TextField
              id={props.fieldName}
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              margin={textMargin}
              fullWidth={props.fullWidth}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputProps={{
                inputComponent: getTextControl_EmailFormat,
                shrink: "true",
              }}
            />
          );
          break;
        //=======================================================================
        case "money":
          fieldElement = (
            <TextField
              id={props.fieldName}
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              margin={textMargin}
              fullWidth={props.fullWidth}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputProps={{
                inputComponent: getTextControl_NumberFormatMoney,
                shrink: "true",
              }}
            />
          );
          break;
        //=======================================================================
        case "number":
          fieldElement = (
            <TextField
              id={props.fieldName}
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              margin={textMargin}
              fullWidth={props.fullWidth}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputProps={{
                inputComponent: getTextControl_NumberFormat,
                shrink: "true",
              }}
            />
          );
          break;
        //=======================================================================
        case "phone":
          fieldElement = (
            <TextField
              id={props.fieldName}
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              onKeyPress={props.onKeyPress}
              margin={textMargin}
              fullWidth={props.fullWidth}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputProps={{
                inputComponent: getTextControl_PhoneFormat,
                shrink: "true",
              }}
            />
          );
          break;
        //=======================================================================
        case "radioGroup":
          // if (doLog()) console.log('[FormField] fieldName:',  props.fieldName);
          // if (doLog()) console.log('[FormField] value:',  props.value);
          // if (doLog()) console.log('[FormField] choices:',  props.choices);
          let choiceLabels = [];
          for (let recKey in props.choices) {
            const choice = props.choices[recKey];
            choiceLabels.push(
              <FormControlLabel
                label={choice.label}
                value={choice.value}
                control={<Radio color="primary" />}
                key={recKey}
              />
            );
          }
          fieldElement = (
            <Fragment>
              <RadioGroup
                value={props.value}
                onChange={props.onChange}
                row={true}
              >
                {choiceLabels}
              </RadioGroup>
            </Fragment>
          );
          break;
        //=======================================================================
        case "select":
          if (doLog()) console.log("[FormField] in select");
          if (props.value !== null) {
            let value = props.value;
            let options = <MenuItem></MenuItem>;
            if (props.value === null) value = -1;
            if (
              props.optionList &&
              props.optionList !== null &&
              props.optionList.length > 0
            ) {
              if (props.editMode) {
                options = props.optionList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ));
              } else {
                options = (
                  <MenuItem
                    key={props.fieldValue.value}
                    value={props.fieldValue.value}
                  >
                    {props.fieldValue.label}
                  </MenuItem>
                );
              }
            }

            // //Using react-dropdown-select
            // fieldElement = (
            //   <Select
            //     options={props.optionList}
            //     onChange={(values) => {
            //         // if (doLog()) console.log('[FormField].select fieldName:' + props.fieldName + ' selectValueFieldName:' + props.selectValueFieldName + " selectListName:" + props.selectListName);
            //         props.onChange(values[0], props.fieldName, props.selectListName);
            //         // props.onChange(e);
            //       }}
            //     />
            // );

            //Using select prop of TextField
            fieldElement = (
              <TextField
                className={classes.FormField}
                id={props.fieldName}
                select
                value={notNull(value)}
                onChange={(e) => {
                  // if (doLog()) console.log('[FormField].select fieldName:' + props.fieldName + ' selectValueFieldName:' + props.selectValueFieldName + " selectListName:" + props.selectListName);
                  props.onChange(e, props.fieldName, props.selectListName);
                  // props.onChange(e);
                }}
                margin={textMargin}
                fullWidth={props.fullWidth}
                variant={textVariant}
                label={fieldLabel}
                required={props.required}
                error={error}
                helperText={validationError}
                notched={textNotched}
                disabled={disabled}
                InputLabelProps={{ shrink: true }}
              >
                {options}
              </TextField>
            );

            // //Using Autocomplete
            // if (props.value !== null) {
            //   let value = props.value;
            //   let options = <MenuItem></MenuItem>;
            //   if (props.value === null) value = -1;
            //   if (props.optionList && props.optionList !== null && props.optionList.length > 0) {
            //     if (props.editMode)
            //     {
            //       options = props.optionList.map((option) => (
            //         <MenuItem key={option.value} value={option.value}>
            //           {option.label}
            //         </MenuItem>
            //       ))
            //     } else {
            //       options =
            //       <MenuItem key={props.fieldValue.value} value={props.fieldValue.value}>
            //           {props.fieldValue.label}
            //       </MenuItem>
            //     }
            //   }
            //     fieldElement = (
            //       <Autocomplete
            //         className={classes.FormField}
            //         id={props.fieldName}
            //         select
            //         value={notNull(value)}
            //         onChange = {(e) => {
            //           // if (doLog()) console.log('[FormField].select fieldName:' + props.fieldName + ' selectValueFieldName:' + props.selectValueFieldName + " selectListName:" + props.selectListName);
            //           props.onChange(e, props.fieldName, props.selectListName);
            //           // props.onChange(e);
            //         }}
            //         margin={textMargin}
            //         fullWidth={props.fullWidth}
            //         variant={textVariant}
            //         label={fieldLabel}
            //         required={props.required}
            //         error={error}
            //         helperText={validationError}
            //         notched={textNotched}
            //         InputLabelProps={{
            //           shrink: true,
            //         }}
            //         renderInput={(params) => (
            //           <TextField
            //             {...params}
            //             label={fieldLabel}
            //             inputProps={{
            //               ...params.inputProps,
            //               autoComplete: 'new-password', // disable autocomplete and autofill
            //             }}
            //           />
            //         )}                >
            //         {options}
            //       </Autocomplete>
            //     );
          }
          break;
        //=======================================================================
        case "datagridsearch":
          // if (doLog()) console.log('[FormField] datagridsearch props:', props);
          fieldElement = (
            <TextField
              variant="standard"
              value={notNull(props.searchText)}
              onChange={props.onChange}
              placeholder="Search..."
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" color="action" />,
                endAdornment: (
                  <IconButton
                    title="Clear"
                    aria-label="Clear"
                    size="small"
                    style={{
                      visibility: props.searchText ? "visible" : "hidden",
                      borderRadius: "57%",
                      paddingRight: "1px",
                      margin: "0",
                      fontSize: "1.25rem",
                    }}
                    onClick={props.gridSearchClickFunction}
                  >
                    <ClearIcon fontSize="small" color="action" />
                  </IconButton>
                ),
              }}
              sx={{
                width: { xs: 1, sm: "auto" },
                m: (theme) => theme.spacing(1, 0.5, 1.5),
                "& .MuiSvgIcon-root": {
                  mr: 0.5,
                },
                "& .MuiInput-underline:before": {
                  borderBottom: 1,
                  borderColor: "divider",
                },
              }}
            />
          );
          break;

        case "datagrid":
          // if (doLog()) console.log('[FormField] datagrid props:', props);
          const { rowHeight, headerHeight } = DEFAULT_GRID_OPTIONS;
          let gridBorderColor = {};
          let gridRequiredText = null;
          if (props.required) {
            gridBorderColor = { borderColor: "red" };
            gridRequiredText = (
              <p className={classes.SeparateRequiredText}>Required.</p>
            );
            if (hasValue(props.value)) {
              gridBorderColor = {};
              gridRequiredText = null;
            }
          }

          fieldElement = (
            <Fragment>
              {/* Moved to datagridsearch:
              <TextField
                variant="standard"
                value={notNull(props.searchText)}
                onChange={props.onChange}
                placeholder="Search..."
                InputProps={{
                  startAdornment: (
                    <SearchIcon fontSize="small" color="action" />
                  ),
                  endAdornment: (
                    <IconButton
                      title="Clear"
                      aria-label="Clear"
                      size="small"
                      style={{
                        visibility: props.searchText ? "visible" : "hidden",
                        borderRadius: "57%",
                        paddingRight: "1px",
                        margin: "0",
                        fontSize: "1.25rem",
                      }}
                      onClick={props.gridSearchClickFunction}
                    >
                      <ClearIcon fontSize="small" color="action" />
                    </IconButton>
                  ),
                }}
                sx={{
                  width: { xs: 1, sm: "auto" },
                  m: (theme) => theme.spacing(1, 0.5, 1.5),
                  "& .MuiSvgIcon-root": {
                    mr: 0.5,
                  },
                  "& .MuiInput-underline:before": {
                    borderBottom: 1,
                    borderColor: "divider",
                  },
                }}
              /> */}
              <div
                style={{ height: headerHeight + rowHeight * props.rowCount }}
              >
                {/* <CoreDataGrid */}
                <DataGrid
                  rows={props.gridRows}
                  columns={props.gridColumns}
                  hideFooter={props.hideFooter}
                  onRowClick={props.gridRowClickFunction}
                  getRowHeight={() => "auto"}
                  sx={gridBorderColor}
                  checkboxSelection
                  selectionModel={props.selectedRows}
                  onSelectionModelChange={props.gridRowCheckBoxFunction}
                />
              </div>
              {gridRequiredText}
            </Fragment>
          );
          break;
        //=======================================================================
        case "date":
          fieldElement = (
            // <DatePicker
            //   keyboard
            //   inputVariant="outlined"
            //   label={fieldLabel}
            //   format="MM/dd/yyyy"
            //   mask={(value) =>
            //     value
            //       ? [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]
            //       : []
            //   }
            //   value={props.value}
            //   onChange={props.onChange}
            //   disableOpenOnEnter
            //   animateYearScrolling={false}
            //   autoOk={true}
            //   clearable={false}
            //   disableFuture={true}
            //   showTodayButton={true}
            // />

            // <input
            //   label={fieldLabel}
            //   value={props.value}
            //   onChange={props.onChange}
            //   />

            //Works fine, but no calendar
            //Use handleTextChange in Form.js
            <TextField
              id={props.fieldName}
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              onKeyPress={props.onKeyPress}
              margin={textMargin}
              fullWidth={props.fullWidth}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputProps={{
                inputComponent: getTextControl_DateFormat,
                shrink: "true",
              }}
            />
          );
          break;
        //=======================================================================
        case "datepicker":
          fieldElement = (
            //Use handleDateChange in Form.js
            <KeyboardDatePicker
              className={classes.FormField}
              variant="modal"
              inputVariant="outlined"
              label={fieldLabel}
              value={props.value}
              onChange={props.onChange}
              onError={console.log}
              disablePast={props.disablePast}
              disableFuture={props.disableFuture}
              // clearable
              format="MM/dd/yyyy"
              style={{ width: "200px" }}
              invalidDateMessage=""
              required={props.required}
            />
          );
          break;
        //=======================================================================
        case "datetime":
          fieldElement = (
            <KeyboardDateTimePicker
              className={classes.FormField}
              variant="modal"
              inputVariant="outlined"
              ampm={true}
              label={fieldLabel}
              value={props.value}
              onChange={props.onChange}
              onError={console.log}
              disablePast={props.disablePast}
              disableFuture={props.disableFuture}
              disabled={disabled}
              format="MM/dd/yyyy hh:mm a"
              style={{ width: "245px" }}
            />
          );
          break;
        //=======================================================================
        case "password":
          fieldElement = (
            <TextField
              id={props.fieldName}
              type="password"
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              onKeyPress={props.onKeyPress}
              margin={textMargin}
              fullWidth={props.fullWidth}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputLabelProps={{
                shrink: true,
              }}
            />
          );
          break;
        //=======================================================================
        case "ssn":
          fieldElement = (
            <TextField
              id={props.fieldName}
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              onKeyPress={props.onKeyPress}
              margin={textMargin}
              fullWidth={props.fullWidth}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputProps={{
                inputComponent: getTextControl_SSNFormat,
                shrink: "true",
              }}
            />
          );
          break;
        //=======================================================================
        case "height":
          fieldElement = (
            <TextField
              id={props.fieldName}
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              onKeyPress={props.onKeyPress}
              margin={textMargin}
              fullWidth={props.fullWidth}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputProps={{
                inputComponent: getTextControl_HeightFormat,
                shrink: "true",
              }}
            />
          );
          break;
        //=======================================================================
        default:
          fieldElement = (
            <TextField
              id={props.fieldName}
              className={classes.FormField}
              value={props.value}
              onChange={props.onChange}
              // onKeyPress={props.onKeyPress}
              margin={textMargin}
              fullWidth={props.fullWidth}
              multiline={props.multiline}
              minRows={rowCount}
              // rows={rowCount}
              variant={textVariant}
              label={fieldLabel}
              required={props.required}
              error={error}
              helperText={validationError}
              notched={textNotched}
              disabled={disabled}
              InputLabelProps={{
                shrink: true,
              }}
            />
          );
      }
    } else {
      switch (props.inputType) {
        //=======================================================================
        case "money":
          fieldElement = (
            <NumberFormat
              thousandSeparator={true}
              prefix={"$"}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType={"text"}
              value={props.value}
            />
          );
          break;
        //=======================================================================
        case "number":
          fieldElement = (
            <NumberFormat
              thousandSeparator={true}
              displayType={"text"}
              value={props.value}
            />
          );
          break;
        //=======================================================================
        case "phone":
          fieldElement = (
            <NumberFormat
              format="(###) ###-####"
              displayType={"text"}
              value={props.value}
            />
          );
          break;
        //=======================================================================
        case "radioGroup":
          // if (doLog()) console.log('[FormField] fieldName:',  props.fieldName);
          // if (doLog()) console.log('[FormField] value:',  props.value);
          // if (doLog()) console.log('[FormField] choices:',  props.choices);
          let choiceLabels = [];
          for (let recKey in props.choices) {
            const choice = props.choices[recKey];
            choiceLabels.push(
              <FormControlLabel
                label={choice.label}
                value={choice.value}
                control={<Radio color="primary" />}
                key={recKey}
              />
            );
          }
          fieldElement = (
            <Fragment>
              <RadioGroup
                value={props.value}
                onChange={props.onChange}
                row={true}
                disabled
              >
                {choiceLabels}
              </RadioGroup>
            </Fragment>
          );
          break;
        //=======================================================================
        case "select":
          fieldElement = props.value.label;
          break;
        //=======================================================================
        case "checkbox":
          // if (doLog()) console.log('[FormField] fieldName:',  props.fieldName);
          // if (doLog()) console.log('[FormField] value:',  props.value);
          // if (doLog()) console.log('[FormField] checkedValue:',  props.checkedValue);
          // fieldElement = (props.value ? "" : "Not ") + fieldLabel
          fieldElement = (
            <Fragment>
              <Checkbox
                checked={props.value === props.checkedValue}
                onChange={props.onChange}
                color="default"
                disabled
              />
              {fieldLabel}
            </Fragment>
          );
          break;
        //=======================================================================
        case "date":
          fieldElement = getMMDDYYYY(notNull(props.value));
          break;
        //=======================================================================
        default:
          fieldElement = props.value;
      }
    }
  }
  if (!showLabel) separateLabel = null;

  // if (doLog()) console.log('[FormField] fieldElement:' + fieldElement);
  return (
    <Fragment>
      {separateLabel}
      {fieldElement}
      {/* {validationError} */}
    </Fragment>
  );
};

// export default formField;
export default React.memo(formField, (prev, next) => {
  // if (doLog()) console.log("[FormField] memo prev:", prev);
  // if (doLog()) console.log("[FormField] memo next:", next);
  const noChange =
    prev.value === next.value &&
    prev.validation === next.validation &&
    prev.label === next.label &&
    (hasValue(prev.gridRows) && hasValue(next.gridRows) && prev.gridRows === next.gridRows) &&
    prev.required === next.required;
  if (!noChange) {
    if (prev.value !== next.value) {
      if (doLog())
        console.log(
          "[FormField] memo changed inputType:",
          prev.inputType +
            " label:" +
            prev.label +
            " prev value:" +
            prev.value +
            " next value:" +
            next.value +
            " prev required:" +
            prev.required +
            " next required:" +
            next.required
        );
    }
    else {
      if (doLog())
        console.log(
          "[FormField] memo changed inputType:",
          prev.inputType +
            " label:" +
            prev.label
        );
    }
  }
  // Note: memo "memorizes" the last instances of the component and skips rendering it unless it changed
  return (
    noChange
  );
});
